import { render, staticRenderFns } from "./ChipStat.vue?vue&type=template&id=e4a6ab4c&scoped=true"
import script from "./ChipStat.vue?vue&type=script&lang=js"
export * from "./ChipStat.vue?vue&type=script&lang=js"
import style0 from "./ChipStat.vue?vue&type=style&index=0&id=e4a6ab4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a6ab4c",
  null
  
)

export default component.exports